export { UpsellSliderItem } from './UpsellSliderItem';
